import React from "react";
import NavigationDrawer from "./../../../components/NavigationDrawer/index";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import { Grid } from "@mui/material";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import Profile from "./Profile";
import AllRolls from "./AllRolls";
import AllUsers from "./AllUsers";
import Control from "./Control";
import Privacy from "./Privacy";
import TermsAndConditon from "./Terms";
import AboutUsPage from "./AboutUs";
import CookiePolicyPage from "./CookiePolicy";
import ContactUsPage from "./ContactUs";
import InsurancePolicy from "./InsurancePolicy";
import WorkerGuidancePolicy from "./workerGuidancePolicy";
import CheckoutPromotionalImages from "./CheckoutPromotionalImages";
import CharityPage from "./Charity";
import DeliveryInformationPage from "./DeliveryInformation";
import ReturnAndRefundPolicyPage from "./ReturnAndRefund";

const tabs = [
  { label: "personalDetails", value: "personal" },
  { label: "roles", value: "rolls" },
  { label: "users", value: "users" },
  { label: "control", value: "control" },
  { label: "checkoutPromotionalImages", value: "checkout_promotional_images" },
  { label: "privacyPolicy", value: "privacy" },
  { label: "termsAndConditions", value: "terms" },
  { label: "aboutUs", value: "about_us" },
  { label: "deliveryInformation", value: "delivery_information" },
  { label: "cookiePolicy", value: "cookie_policy" },
  { label: "returnAndRefundPolicy", value: "return_and_refund" },
  { label: "contactUs", value: "contact_us" },
  { label: "insurancePolicy", value: "insurance_policy" },
  { label: "workersGuidancePolicy", value: "worker_guidance_policy" },
  { label: "charity", value: "charity" },
];

function AdminSettings() {
  const dispatch = useDispatch();
  // Redux states
  const activeTab = useSelector((state) => state.activeTab.tabs);

  // Function

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, admin_setting: tab }));
  };

  return (
    <NavigationDrawer>
      <Grid container spacing={1}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading={"settings"}
            tabs={tabs}
            activeTab={activeTab.admin_setting}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {activeTab.admin_setting === "personal" ? (
            <Profile />
          ) : activeTab.admin_setting === "rolls" ? (
            <AllRolls />
          ) : activeTab.admin_setting === "users" ? (
            <AllUsers />
          ) : activeTab.admin_setting === "control" ? (
            <Control />
          ) : activeTab.admin_setting === "checkout_promotional_images" ? (
            <CheckoutPromotionalImages />
          ) : activeTab.admin_setting === "privacy" ? (
            <Privacy />
          ) : activeTab.admin_setting === "terms" ? (
            <TermsAndConditon />
          ) : activeTab.admin_setting === "about_us" ? (
            <AboutUsPage />
          ) : activeTab.admin_setting === "delivery_information" ? (
            <DeliveryInformationPage />
          ) : activeTab.admin_setting === "cookie_policy" ? (
            <CookiePolicyPage />
          ) : activeTab.admin_setting === "return_and_refund" ? (
            <ReturnAndRefundPolicyPage />
          ) : activeTab.admin_setting === "contact_us" ? (
            <ContactUsPage />
          ) : activeTab.admin_setting === "insurance_policy" ? (
            <InsurancePolicy />
          ) : activeTab.admin_setting === "worker_guidance_policy" ? (
            <WorkerGuidancePolicy />
          ) : activeTab.admin_setting === "charity" ? (
            <CharityPage />
          ) : null}
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
}

export default AdminSettings;
